// extracted by mini-css-extract-plugin
export default {"root":"AddingFormItem_root__UP9Yg","label":"AddingFormItem_label__IYbet","center":"AddingFormItem_center__3i+Ne","placeHolderShimmer":"AddingFormItem_placeHolderShimmer__4zwoe"};